.price {
  font-size: 0.875rem;
  line-height: 0.875rem;
  font-weight: 700; 
}

.salePrice {
  display: inline-flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  font-weight: 700;
  column-gap: 0.5rem;
  row-gap: 0.25rem;
  /* margin-right: 5px; */
}

.price:not(.onSale) .salePrice,
.price.noCompare .salePrice {
  display: none;
}

.price.onSale:not(.noCompare) .regularPrice {
  display: none;
}

.saleBadge,
.saleTag {
  /* background-color: var(--color-sale); */
  /* background-color: #03C3F4; */
  /* color: var(--color-sale-text); */
  background-color: var(--sale-badge-background);
  color: var(--sale-badge-color);
  text-transform: uppercase;
  font-weight: 700;
  padding: 0.26rem 0.4rem 0.2rem 0.4rem;
  border-radius: 100px;
  letter-spacing: .5px;
  line-height: 11px;
  font-size: 11px;
}
.regularPrice {
  margin-right: 5px;
}

@supports (not (inset: 10px)) {
  .salePrice {
    margin-top: 0.25rem;
    margin-left: 0.5rem;
  }

  .salePrice > * {
    margin-top: -0.25rem;
    margin-left: -0.5rem;
  }
}

.bf40{
  tab-size: 4;
  -webkit-text-size-adjust: 100%;
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --font-body-family: 'Proxima Nova', sans-serif;
  --font-body-style: normal;
  --font-body-weight: 400;
  --font-heading-settings: '1num' on, 'pnum' on, 'ss09' on, 'salt' on, 'ss01' on, 'ss03' on, 'ss05' on, 'ss08' on,
        'ss11' on;
  --font-heading-family: 'Raleway', sans-serif;
  --font-heading-style: normal;
  --font-heading-weight: 800;
  --font-heading-spacing: 0.02em;
  --color-primary: #4287f5;
  --color-primary-dark: #2a78f4;
  --color-primary-darker: #1268f2;
  --color-primary-text: #fff;
  --color-sale: #da2f0c;
  --color-sale-text: rgb(var(--color-white));
  --color-gray-50: 250, 250, 250;
  --color-gray-100: 244, 244, 245;
  --color-gray-200: 228, 228, 231;
  --color-gray-300: 212, 212, 216;
  --color-gray-400: 161, 161, 170;
  --color-gray-500: 113, 113, 122;
  --color-gray-600: 82, 82, 91;
  --color-gray-700: 63, 63, 70;
  --color-gray-800: 39, 39, 42;
  --color-gray-900: 24, 24, 27;
  --color-white: 255, 255, 255;
  --color-black: 0, 0, 0;
  --color-render: 236, 238, 240;
  --grid-mobile-horizontal-spacing: 1rem;
  --grid-mobile-vertical-spacing: 1rem;
  --grid-desktop-horizontal-spacing: 1rem;
  --grid-desktop-vertical-spacing: 1rem;
  --page-width: 1280px;
  --swym-remind-cta-bg-color: #00a65a;
  --swym-remind-cta-text-color: white;
  font-family: var(--font-body-family);
  font-style: var(--font-body-style);
  --color-background: var(--color-white);
  --color-background-soft: var(--color-gray-100);
  --color-background-softer: var(--color-gray-200);
  --color-background-softest: var(--color-gray-300);
  --color-foreground: var(--color-gray-900);
  --color-foreground-soft: var(--color-gray-800);
  --color-foreground-softer: var(--color-gray-700);
  --color-foreground-softest: var(--color-gray-400);
  --color-border: var(--color-gray-300);
  list-style: none;
  box-sizing: border-box;
  border-width: 0;
  border-style: solid;
  border-color: rgb(var(--color-border));
  text-transform: uppercase;
  color: var(--color-sale-text);
  padding: 0 .25rem;
  font-size: .875rem;
  font-weight: 700;
  line-height: 1rem;
  justify-content: center;
  align-items: center;
  background-color: #FF268F;
}
 
.promotionBadge {
  background: var(--promoBadgeColour);
  color:var(--promoBadgeTextColour);
}